// import { useState, useEffect, useCallback } from "react";
// import {
//   getAllStoriesForAdmin,
//   updateStoryStatusByAdmin,
//   deleteStory,
//   getAllReporters, // apna actual path/service adjust karein
// } from "../../../services/adminService";
// import { getCategories } from "../../../services/apiService"; // apna actual path adjust karein

// const STATUS_STYLES = {
//   posted: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
//   pending_approval: "bg-amber-50 text-amber-700 ring-amber-600/20",
//   rejected: "bg-rose-50 text-rose-700 ring-rose-600/20",
// };
// const STATUS_LABEL = {
//   posted: "Posted",
//   pending_approval: "Pending",
//   rejected: "Rejected",
// };

// function StatusBadge({ status }) {
//   return (
//     <span
//       className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${
//         STATUS_STYLES[status] || "bg-slate-100 text-slate-600 ring-slate-500/20"
//       }`}
//     >
//       {STATUS_LABEL[status] || status}
//     </span>
//   );
// }

// // ---- Reject reason modal ----
// function RejectModal({ story, onClose, onConfirm }) {
//   const [reason, setReason] = useState("");
//   if (!story) return null;
//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
//       <div className="w-full max-w-md rounded-lg bg-white p-6">
//         <h3 className="font-serif text-lg text-[#1E2430]">Story reject karein</h3>
//         <p className="mt-1 text-sm text-[#6B6357]">"{story.title}"</p>
//         <textarea
//           value={reason}
//           onChange={(e) => setReason(e.target.value)}
//           rows={3}
//           placeholder="Reject karne ki wajah likhein (reporter ko dikhegi)"
//           className="mt-3 w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-rose-500/30"
//         />
//         <div className="mt-4 flex justify-end gap-2">
//           <button onClick={onClose} className="rounded-md px-4 py-2 text-sm text-[#6B6357] hover:bg-[#F6F4EF]">
//             Cancel
//           </button>
//           <button
//             onClick={() => onConfirm(reason)}
//             className="rounded-md bg-rose-600 px-4 py-2 text-sm font-medium text-white hover:bg-rose-700"
//           >
//             Reject karein
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// const EMPTY_FILTERS = {
//   status: "all",
//   category: "",
//   reporter: "",
//   startDate: "",
//   endDate: "",
//   search: "",
// };

// export default function AllStoryAdminManagement() {
//   const [stories, setStories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   // ---- Filter dropdown data ----
//   const [reportersDropdown, setReportersDropdown] = useState([]);
//   const [categoriesDropdown, setCategoriesDropdown] = useState([]);

//   const [filters, setFilters] = useState(EMPTY_FILTERS);

//   const [page, setPage] = useState(1);
//   const [limit] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalCount, setTotalCount] = useState(0);

//   const [rejectTarget, setRejectTarget] = useState(null);

//   // ---- Load reporters + categories for filter dropdowns ----
//   useEffect(() => {
//     const loadInitial = async () => {
//       try {
//         const [catsRes, reportersRes] = await Promise.all([
//           getCategories(),
//           getAllReporters(),
//         ]);
//         setCategoriesDropdown(catsRes.data || []);
//         setReportersDropdown(reportersRes.data || []);
//       } catch (err) {
//         console.error("Initial filter data load failed:", err);
//       }
//     };
//     loadInitial();
//   }, []);

//   const loadStories = useCallback(async () => {
//     setLoading(true);
//     setError("");
//     try {
//       const res = await getAllStoriesForAdmin({
//         status: filters.status,
//         category: filters.category || undefined,
//         reporter: filters.reporter || undefined,
//         startDate: filters.startDate || undefined,
//         endDate: filters.endDate || undefined,
//         search: filters.search || undefined,
//         page,
//         limit,
//       });
//       setStories(res.data || []);
//       setTotalPages(res.totalPages || 1);
//       setTotalCount(res.totalCount || 0);
//     } catch (err) {
//       setError(err.response?.data?.message || "Stories load nahi ho sakin.");
//     } finally {
//       setLoading(false);
//     }
//   }, [filters, page, limit]);

//   useEffect(() => {
//     loadStories();
//   }, [loadStories]);

//   const handleFilterChange = (name, value) => {
//     setFilters((prev) => ({ ...prev, [name]: value }));
//     setPage(1);
//   };

//   const clearFilters = () => {
//     setFilters(EMPTY_FILTERS);
//     setPage(1);
//   };

//   const handleApprove = async (story) => {
//     try {
//       await updateStoryStatusByAdmin(story._id, { status: "posted" });
//       loadStories();
//     } catch (err) {
//       alert(err.response?.data?.message || "Approve nahi ho paya.");
//     }
//   };

//   const handleResetToPending = async (story) => {
//     try {
//       await updateStoryStatusByAdmin(story._id, { status: "pending_approval" });
//       loadStories();
//     } catch (err) {
//       alert(err.response?.data?.message || "Update nahi ho paya.");
//     }
//   };

//   const confirmReject = async (reason) => {
//     try {
//       await updateStoryStatusByAdmin(rejectTarget._id, { status: "rejected", rejectionReason: reason });
//       setRejectTarget(null);
//       loadStories();
//     } catch (err) {
//       alert(err.response?.data?.message || "Reject nahi ho paya.");
//     }
//   };

//   const handleDelete = async (storyId) => {
//     if (!window.confirm("Ye story permanently delete kar dein?")) return;
//     try {
//       await deleteStory(storyId);
//       loadStories();
//     } catch (err) {
//       alert(err.response?.data?.message || "Delete nahi ho paya.");
//     }
//   };

//   const statusFilters = [
//     { key: "all", label: "All" },
//     { key: "pending_approval", label: "Pending" },
//     { key: "posted", label: "Posted" },
//     { key: "rejected", label: "Rejected" },
//   ];

//   return (
//     <div className="min-h-screen bg-[#F6F4EF]">
//       <header className="border-b border-[#E2DDD1] bg-white">
//         <div className="mx-auto max-w-6xl px-6 py-6">
//           <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#B4501F]">Admin Console</p>
//           <h1 className="mt-1 font-serif text-2xl text-[#1E2430]">Stories Moderation</h1>
//           <p className="mt-1 text-sm text-[#6B6357]">{totalCount} total stories</p>
//         </div>
//       </header>

//       <main className="mx-auto max-w-6xl px-6 py-8 space-y-6">
//         {/* ---- Filters bar (Shorts-style) ---- */}
//         <div className="rounded-lg border border-[#E2DDD1] bg-white p-4">
//           <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
//             {/* Status pills row spans full width on top */}
//             <div className="col-span-full flex flex-wrap gap-2">
//               {statusFilters.map((f) => (
//                 <button
//                   key={f.key}
//                   onClick={() => handleFilterChange("status", f.key)}
//                   className={`rounded-full px-4 py-1.5 text-sm font-medium transition ${
//                     filters.status === f.key
//                       ? "bg-[#1E2430] text-white"
//                       : "bg-white text-[#6B6357] ring-1 ring-[#E2DDD1] hover:bg-[#F0ECE0]"
//                   }`}
//                 >
//                   {f.label}
//                 </button>
//               ))}
//             </div>

//             {/* Reporter */}
//             <select
//               value={filters.reporter}
//               onChange={(e) => handleFilterChange("reporter", e.target.value)}
//               className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
//             >
//               <option value="">All Reporters</option>
//               {reportersDropdown.map((rep) => (
//                 <option key={rep.id || rep._id} value={rep.id || rep._id}>
//                   {rep.name}
//                 </option>
//               ))}
//             </select>

//             {/* Category */}
//             <select
//               value={filters.category}
//               onChange={(e) => handleFilterChange("category", e.target.value)}
//               className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
//             >
//               <option value="">All Categories</option>
//               {categoriesDropdown.map((cat) => (
//                 <option key={cat._id} value={cat._id}>
//                   {cat.name}
//                 </option>
//               ))}
//             </select>

//             {/* Search */}
//             <input
//               type="text"
//               value={filters.search}
//               onChange={(e) => handleFilterChange("search", e.target.value)}
//               placeholder="Title se search karein..."
//               className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
//             />

//             {/* From Date */}
//             <input
//               type="date"
//               value={filters.startDate}
//               onChange={(e) => handleFilterChange("startDate", e.target.value)}
//               className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
//             />

//             {/* To Date */}
//             <input
//               type="date"
//               value={filters.endDate}
//               onChange={(e) => handleFilterChange("endDate", e.target.value)}
//               className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
//             />

//             {/* Clear */}
//             <button
//               onClick={clearFilters}
//               className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm font-medium text-[#6B6357] hover:bg-[#F6F4EF]"
//             >
//               Clear Filters
//             </button>
//           </div>
//         </div>

//         {error && (
//           <div className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700 ring-1 ring-rose-600/20">{error}</div>
//         )}

//         {loading ? (
//           <p className="text-sm text-[#6B6357]">Load ho raha hai...</p>
//         ) : stories.length === 0 ? (
//           <div className="rounded-lg border border-dashed border-[#D8D2C4] bg-white p-10 text-center text-sm text-[#6B6357]">
//             Is filter ke liye koi story nahi mili.
//           </div>
//         ) : (
//           <div className="overflow-hidden rounded-lg border border-[#E2DDD1] bg-white">
//             <table className="w-full text-left text-sm">
//               <thead className="bg-[#F6F4EF] text-xs uppercase tracking-wide text-[#6B6357]">
//                 <tr>
//                   <th className="px-4 py-3">Title</th>
//                   <th className="px-4 py-3">Reporter</th>
//                   <th className="px-4 py-3">Category</th>
//                   <th className="px-4 py-3">Status</th>
//                   <th className="px-4 py-3">Date</th>
//                   <th className="px-4 py-3 text-right">Actions</th>
//                 </tr>
//               </thead>
//               <tbody className="divide-y divide-[#EDE8DC]">
//                 {stories.map((story) => (
//                   <tr key={story._id}>
//                     <td className="px-4 py-3 font-medium text-[#1E2430] max-w-xs truncate">{story.title}</td>
//                     <td className="px-4 py-3 text-[#6B6357]">{story.createdBy?.name || "—"}</td>
//                     <td className="px-4 py-3 text-[#6B6357]">{story.category?.name || "—"}</td>
//                     <td className="px-4 py-3">
//                       <StatusBadge status={story.status} />
//                     </td>
//                     <td className="px-4 py-3 text-[#6B6357]">
//                       {new Date(story.createdAt).toLocaleDateString("en-IN")}
//                     </td>
//                     <td className="px-4 py-3 text-right space-x-3 whitespace-nowrap">
//                       {story.status !== "posted" && (
//                         <button
//                           onClick={() => handleApprove(story)}
//                           className="text-xs font-medium text-emerald-700 hover:underline"
//                         >
//                           Approve
//                         </button>
//                       )}
//                       {story.status !== "rejected" && (
//                         <button
//                           onClick={() => setRejectTarget(story)}
//                           className="text-xs font-medium text-rose-600 hover:underline"
//                         >
//                           Reject
//                         </button>
//                       )}
//                       {story.status !== "pending_approval" && (
//                         <button
//                           onClick={() => handleResetToPending(story)}
//                           className="text-xs font-medium text-amber-700 hover:underline"
//                         >
//                           Reset
//                         </button>
//                       )}
//                       <button
//                         onClick={() => handleDelete(story._id)}
//                         className="text-xs font-medium text-[#6B6357] hover:underline"
//                       >
//                         Delete
//                       </button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {totalPages > 1 && (
//           <div className="flex items-center justify-center gap-2 pt-2">
//             <button
//               disabled={page <= 1}
//               onClick={() => setPage((p) => p - 1)}
//               className="rounded-md px-3 py-1.5 text-sm text-[#6B6357] ring-1 ring-[#E2DDD1] disabled:opacity-40"
//             >
//               Pichla
//             </button>
//             <span className="text-sm text-[#6B6357]">
//               Page {page} / {totalPages}
//             </span>
//             <button
//               disabled={page >= totalPages}
//               onClick={() => setPage((p) => p + 1)}
//               className="rounded-md px-3 py-1.5 text-sm text-[#6B6357] ring-1 ring-[#E2DDD1] disabled:opacity-40"
//             >
//               Agla
//             </button>
//           </div>
//         )}
//       </main>

//       <RejectModal story={rejectTarget} onClose={() => setRejectTarget(null)} onConfirm={confirmReject} />
//     </div>
//   );
// }

import { useState, useEffect, useCallback } from "react";
import {
  getAllStoriesForAdmin,
  updateStoryStatusByAdmin,
  deleteStory,
  getAllReporters, // apna actual path/service adjust karein
} from "../../../services/adminService";
import { getCategories } from "../../../services/apiService"; // apna actual path adjust karein

const STATUS_STYLES = {
  posted: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  pending_approval: "bg-amber-50 text-amber-700 ring-amber-600/20",
  rejected: "bg-rose-50 text-rose-700 ring-rose-600/20",
};
const STATUS_LABEL = {
  posted: "Posted",
  pending_approval: "Pending",
  rejected: "Rejected",
};

function StatusBadge({ status }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium ring-1 ring-inset ${
        STATUS_STYLES[status] || "bg-slate-100 text-slate-600 ring-slate-500/20"
      }`}
    >
      {STATUS_LABEL[status] || status}
    </span>
  );
}

// ---- Reject reason modal ----
function RejectModal({ story, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  if (!story) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-6">
        <h3 className="font-serif text-lg text-[#1E2430]">Story reject karein</h3>
        <p className="mt-1 text-sm text-[#6B6357]">"{story.title}"</p>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={3}
          placeholder="Reject karne ki wajah likhein (reporter ko dikhegi)"
          className="mt-3 w-full rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-rose-500/30"
        />
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onClose} className="rounded-md px-4 py-2 text-sm text-[#6B6357] hover:bg-[#F6F4EF]">
            Cancel
          </button>
          <button
            onClick={() => onConfirm(reason)}
            className="rounded-md bg-rose-600 px-4 py-2 text-sm font-medium text-white hover:bg-rose-700"
          >
            Reject karein
          </button>
        </div>
      </div>
    </div>
  );
}

const EMPTY_FILTERS = {
  status: "all",
  category: "",
  reporter: "",
  startDate: "",
  endDate: "",
  search: "",
};

// ---- View story modal: shows all slides + full detail before approve/reject ----
function ViewStoryModal({ story, onClose, onApprove, onReject, onResetToPending }) {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    setActiveSlide(0);
  }, [story]);

  if (!story) return null;

  const slides = story.slides || [];
  const current = slides[activeSlide];

  const renderMedia = (slide) => {
    if (!slide) {
      return (
        <div className="flex h-72 items-center justify-center text-sm text-[#9A917F]">
          Is story me koi slide nahi hai.
        </div>
      );
    }
    if (slide.isExternalLink) {
      return (
        <div className="flex h-72 flex-col items-center justify-center gap-2 bg-[#111827] px-6 text-center text-sm text-white">
          <p className="text-[#9CA3AF]">External link slide</p>
          <a
            href={slide.mediaUrl}
            target="_blank"
            rel="noreferrer"
            className="break-all text-emerald-400 underline"
          >
            {slide.mediaUrl}
          </a>
        </div>
      );
    }
    if (slide.mediaType === "video") {
      return (
        <video
          src={slide.mediaUrl}
          controls
          className="h-72 w-full bg-black object-contain"
        />
      );
    }
    return (
      <img
        src={slide.mediaUrl}
        alt={slide.caption || `Slide ${activeSlide + 1}`}
        className="h-72 w-full object-contain bg-[#0000000d]"
      />
    );
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 py-6">
      <div className="flex max-h-[90vh] w-full max-w-3xl flex-col overflow-hidden rounded-lg bg-white">
        {/* Header */}
        <div className="flex items-start justify-between border-b border-[#E2DDD1] px-6 py-4">
          <div>
            <h3 className="font-serif text-lg text-[#1E2430]">{story.title}</h3>
            <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-[#6B6357]">
              <StatusBadge status={story.status} />
              <span>•</span>
              <span>{story.category?.name || "No category"}</span>
              <span>•</span>
              <span>{new Date(story.createdAt).toLocaleString("en-IN")}</span>
            </div>
          </div>
          <button
            onClick={onClose}
            className="rounded-md px-2 py-1 text-[#6B6357] hover:bg-[#F6F4EF]"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        {/* Body (scrollable) */}
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-5">
          {/* Slide viewer */}
          <div className="overflow-hidden rounded-lg border border-[#E2DDD1]">
            {renderMedia(current)}
          </div>

          {/* Slide thumbnails / navigation */}
          {slides.length > 0 && (
            <div className="space-y-2">
              <div className="flex flex-wrap gap-2">
                {slides.map((s, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveSlide(idx)}
                    className={`h-14 w-14 shrink-0 overflow-hidden rounded-md border-2 ${
                      idx === activeSlide ? "border-[#B4501F]" : "border-transparent"
                    }`}
                  >
                    {s.isExternalLink ? (
                      <div className="flex h-full w-full items-center justify-center bg-[#111827] text-[10px] text-white">
                        Link
                      </div>
                    ) : s.mediaType === "video" ? (
                      <video src={s.mediaUrl} className="h-full w-full object-cover" muted />
                    ) : (
                      <img src={s.mediaUrl} alt="" className="h-full w-full object-cover" />
                    )}
                  </button>
                ))}
              </div>
              {current?.caption && (
                <p className="text-sm text-[#1E2430]">
                  <span className="font-medium text-[#6B6357]">Caption: </span>
                  {current.caption}
                </p>
              )}
              <p className="text-xs text-[#9A917F]">
                Slide {activeSlide + 1} of {slides.length}
              </p>
            </div>
          )}

          {/* Summary */}
          {story.summary && (
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-[#9A917F]">Summary</p>
              <p className="mt-1 text-sm text-[#1E2430]">{story.summary}</p>
            </div>
          )}

          {/* Reporter + review info */}
          <div className="grid grid-cols-2 gap-4 rounded-lg bg-[#F6F4EF] p-4 text-sm">
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-[#9A917F]">Reporter</p>
              <p className="mt-1 text-[#1E2430]">{story.createdBy?.name || "—"}</p>
              <p className="text-xs text-[#6B6357]">{story.createdBy?.email || ""}</p>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-[#9A917F]">Reviewed By</p>
              <p className="mt-1 text-[#1E2430]">{story.reviewedBy?.name || "Not reviewed yet"}</p>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-[#9A917F]">Created</p>
              <p className="mt-1 text-[#1E2430]">{new Date(story.createdAt).toLocaleString("en-IN")}</p>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-[#9A917F]">Last Updated</p>
              <p className="mt-1 text-[#1E2430]">
                {story.updatedAt ? new Date(story.updatedAt).toLocaleString("en-IN") : "—"}
              </p>
            </div>
            {story.publishedAt && (
              <div>
                <p className="text-xs font-semibold uppercase tracking-wide text-[#9A917F]">Published At</p>
                <p className="mt-1 text-[#1E2430]">{new Date(story.publishedAt).toLocaleString("en-IN")}</p>
              </div>
            )}
            {story.shareLink && (
              <div className="col-span-2">
                <p className="text-xs font-semibold uppercase tracking-wide text-[#9A917F]">Share Link</p>
                <a
                  href={story.shareLink}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-1 block break-all text-sm text-[#B4501F] underline"
                >
                  {story.shareLink}
                </a>
              </div>
            )}
          </div>

          {/* Rejection reason, agar hai to highlight karein */}
          {story.status === "rejected" && story.rejectionReason && (
            <div className="rounded-lg bg-rose-50 p-4 ring-1 ring-rose-600/20">
              <p className="text-xs font-semibold uppercase tracking-wide text-rose-700">Rejection Reason</p>
              <p className="mt-1 text-sm text-rose-800">{story.rejectionReason}</p>
            </div>
          )}
        </div>

        {/* Footer actions */}
        <div className="flex flex-wrap justify-end gap-2 border-t border-[#E2DDD1] px-6 py-4">
          {story.status !== "pending_approval" && (
            <button
              onClick={() => onResetToPending(story)}
              className="rounded-md px-4 py-2 text-sm font-medium text-amber-700 ring-1 ring-amber-600/30 hover:bg-amber-50"
            >
              Reset to Pending
            </button>
          )}
          {story.status !== "rejected" && (
            <button
              onClick={onReject}
              className="rounded-md bg-rose-600 px-4 py-2 text-sm font-medium text-white hover:bg-rose-700"
            >
              Reject
            </button>
          )}
          {story.status !== "posted" && (
            <button
              onClick={() => onApprove(story)}
              className="rounded-md bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700"
            >
              Approve
            </button>
          )}
          <button
            onClick={onClose}
            className="rounded-md px-4 py-2 text-sm text-[#6B6357] hover:bg-[#F6F4EF]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default function AllStoryAdminManagement() {
  const [stories, setStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // ---- Filter dropdown data ----
  const [reportersDropdown, setReportersDropdown] = useState([]);
  const [categoriesDropdown, setCategoriesDropdown] = useState([]);

  const [filters, setFilters] = useState(EMPTY_FILTERS);

  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const [rejectTarget, setRejectTarget] = useState(null);
  const [viewTarget, setViewTarget] = useState(null);

  // ---- Load reporters + categories for filter dropdowns ----
  useEffect(() => {
    const loadInitial = async () => {
      try {
        const [catsRes, reportersRes] = await Promise.all([
          getCategories(),
          getAllReporters(),
        ]);
        setCategoriesDropdown(catsRes.data || []);
        setReportersDropdown(reportersRes.data || []);
      } catch (err) {
        console.error("Initial filter data load failed:", err);
      }
    };
    loadInitial();
  }, []);

  const loadStories = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getAllStoriesForAdmin({
        status: filters.status,
        category: filters.category || undefined,
        reporter: filters.reporter || undefined,
        startDate: filters.startDate || undefined,
        endDate: filters.endDate || undefined,
        search: filters.search || undefined,
        page,
        limit,
      });
      setStories(res.data || []);
      setTotalPages(res.totalPages || 1);
      setTotalCount(res.totalCount || 0);
    } catch (err) {
      setError(err.response?.data?.message || "Stories load ");
    } finally {
      setLoading(false);
    }
  }, [filters, page, limit]);

  useEffect(() => {
    loadStories();
  }, [loadStories]);

  const handleFilterChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    setPage(1);
  };

  const clearFilters = () => {
    setFilters(EMPTY_FILTERS);
    setPage(1);
  };

  const handleApprove = async (story) => {
    try {
      await updateStoryStatusByAdmin(story._id, { status: "posted" });
      setViewTarget(null); // view modal se approve hua ho to usko bhi close karein
      loadStories();
    } catch (err) {
      alert(err.response?.data?.message || "Approve nahi ho paya.");
    }
  };

  const handleResetToPending = async (story) => {
    try {
      await updateStoryStatusByAdmin(story._id, { status: "pending_approval" });
      setViewTarget(null);
      loadStories();
    } catch (err) {
      alert(err.response?.data?.message || "Update nahi ho paya.");
    }
  };

  const confirmReject = async (reason) => {
    try {
      await updateStoryStatusByAdmin(rejectTarget._id, { status: "rejected", rejectionReason: reason });
      setRejectTarget(null);
      setViewTarget(null); // view modal se hi reject hua ho to usko bhi close karein
      loadStories();
    } catch (err) {
      alert(err.response?.data?.message || "Reject nahi ho paya.");
    }
  };

  const handleDelete = async (storyId) => {
    if (!window.confirm("Ye story permanently delete kar dein?")) return;
    try {
      await deleteStory(storyId);
      loadStories();
    } catch (err) {
      alert(err.response?.data?.message || "Delete nahi ho paya.");
    }
  };

  const statusFilters = [
    { key: "all", label: "All" },
    { key: "pending_approval", label: "Pending" },
    { key: "posted", label: "Posted" },
    { key: "rejected", label: "Rejected" },
  ];

  return (
    <div className="min-h-screen bg-[#F6F4EF]">
      <header className="border-b border-[#E2DDD1] bg-white">
        <div className="mx-auto max-w-6xl px-6 py-6">
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#B4501F]">Admin Console</p>
          <h1 className="mt-1 font-serif text-2xl text-[#1E2430]">Stories Moderation</h1>
          <p className="mt-1 text-sm text-[#6B6357]">{totalCount} total stories</p>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-8 space-y-6">
        {/* ---- Filters bar (Shorts-style) ---- */}
        <div className="rounded-lg border border-[#E2DDD1] bg-white p-4">
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6">
            {/* Status pills row spans full width on top */}
            <div className="col-span-full flex flex-wrap gap-2">
              {statusFilters.map((f) => (
                <button
                  key={f.key}
                  onClick={() => handleFilterChange("status", f.key)}
                  className={`rounded-full px-4 py-1.5 text-sm font-medium transition ${
                    filters.status === f.key
                      ? "bg-[#1E2430] text-white"
                      : "bg-white text-[#6B6357] ring-1 ring-[#E2DDD1] hover:bg-[#F0ECE0]"
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>

            {/* Reporter */}
            <select
              value={filters.reporter}
              onChange={(e) => handleFilterChange("reporter", e.target.value)}
              className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
            >
              <option value="">All Reporters</option>
              {reportersDropdown.map((rep) => (
                <option key={rep.id || rep._id} value={rep.id || rep._id}>
                  {rep.name}
                </option>
              ))}
            </select>

            {/* Category */}
            <select
              value={filters.category}
              onChange={(e) => handleFilterChange("category", e.target.value)}
              className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
            >
              <option value="">All Categories</option>
              {categoriesDropdown.map((cat) => (
                <option key={cat._id} value={cat._id}>
                  {cat.name}
                </option>
              ))}
            </select>

            {/* Search */}
            <input
              type="text"
              value={filters.search}
              onChange={(e) => handleFilterChange("search", e.target.value)}
              placeholder="Title se search karein..."
              className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
            />

            {/* From Date */}
            <input
              type="date"
              value={filters.startDate}
              onChange={(e) => handleFilterChange("startDate", e.target.value)}
              className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
            />

            {/* To Date */}
            <input
              type="date"
              value={filters.endDate}
              onChange={(e) => handleFilterChange("endDate", e.target.value)}
              className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#B4501F]/40"
            />

            {/* Clear */}
            <button
              onClick={clearFilters}
              className="rounded-md border border-[#D8D2C4] px-3 py-2 text-sm font-medium text-[#6B6357] hover:bg-[#F6F4EF]"
            >
              Clear Filters
            </button>
          </div>
        </div>

        {error && (
          <div className="rounded-md bg-rose-50 px-3 py-2 text-sm text-rose-700 ring-1 ring-rose-600/20">{error}</div>
        )}

        {loading ? (
          <p className="text-sm text-[#6B6357]">Load ho raha hai...</p>
        ) : stories.length === 0 ? (
          <div className="rounded-lg border border-dashed border-[#D8D2C4] bg-white p-10 text-center text-sm text-[#6B6357]">
          .
          </div>
        ) : (
          <div className="overflow-hidden rounded-lg border border-[#E2DDD1] bg-white">
            <table className="w-full text-left text-sm">
              <thead className="bg-[#F6F4EF] text-xs uppercase tracking-wide text-[#6B6357]">
                <tr>
                  <th className="px-4 py-3">Title</th>
                  <th className="px-4 py-3">Reporter</th>
                  <th className="px-4 py-3">Category</th>
                  <th className="px-4 py-3">Status</th>
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3 text-right">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-[#EDE8DC]">
                {stories.map((story) => (
                  <tr key={story._id}>
                    <td className="px-4 py-3 font-medium text-[#1E2430] max-w-xs truncate">{story.title}</td>
                    <td className="px-4 py-3 text-[#6B6357]">{story.createdBy?.name || "—"}</td>
                    <td className="px-4 py-3 text-[#6B6357]">{story.category?.name || "—"}</td>
                    <td className="px-4 py-3">
                      <StatusBadge status={story.status} />
                    </td>
                    <td className="px-4 py-3 text-[#6B6357]">
                      {new Date(story.createdAt).toLocaleDateString("en-IN")}
                    </td>
                    <td className="px-4 py-3 text-right space-x-3 whitespace-nowrap">
                      <button
                        onClick={() => setViewTarget(story)}
                        className="text-xs font-medium text-[#1E2430] hover:underline"
                      >
                        View
                      </button>
                      {story.status !== "posted" && (
                        <button
                          onClick={() => handleApprove(story)}
                          className="text-xs font-medium text-emerald-700 hover:underline"
                        >
                          Approve
                        </button>
                      )}
                      {story.status !== "rejected" && (
                        <button
                          onClick={() => setRejectTarget(story)}
                          className="text-xs font-medium text-rose-600 hover:underline"
                        >
                          Reject
                        </button>
                      )}
                      {story.status !== "pending_approval" && (
                        <button
                          onClick={() => handleResetToPending(story)}
                          className="text-xs font-medium text-amber-700 hover:underline"
                        >
                          Reset
                        </button>
                      )}
                      <button
                        onClick={() => handleDelete(story._id)}
                        className="text-xs font-medium text-[#6B6357] hover:underline"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-2 pt-2">
            <button
              disabled={page <= 1}
              onClick={() => setPage((p) => p - 1)}
              className="rounded-md px-3 py-1.5 text-sm text-[#6B6357] ring-1 ring-[#E2DDD1] disabled:opacity-40"
            >
              Pichla
            </button>
            <span className="text-sm text-[#6B6357]">
              Page {page} / {totalPages}
            </span>
            <button
              disabled={page >= totalPages}
              onClick={() => setPage((p) => p + 1)}
              className="rounded-md px-3 py-1.5 text-sm text-[#6B6357] ring-1 ring-[#E2DDD1] disabled:opacity-40"
            >
              Agla
            </button>
          </div>
        )}
      </main>

      <RejectModal story={rejectTarget} onClose={() => setRejectTarget(null)} onConfirm={confirmReject} />

      <ViewStoryModal
        story={viewTarget}
        onClose={() => setViewTarget(null)}
        onApprove={handleApprove}
        onReject={() => {
          setRejectTarget(viewTarget);
        }}
        onResetToPending={handleResetToPending}
      />
    </div>
  );
}